import template from './tree-diagram.html';
import TreeDiagramRenderer from './tree-renderer.view';

export default () => {
  return {
    restrict: 'E',
    replace: true,
    template,
    link: function ($scope, $element, $attributes) {
      let renderer = $scope.$eval($attributes.renderer);

      if (!renderer instanceof TreeDiagramRenderer) {
        throw new TypeError('"Renderer" must be an instance of TreeDiagramRenderer');
      }

    }
  };
};



// WEBPACK FOOTER //
// ./client/app/components/tree-diagram/tree-renderer.directive.js